module.exports = __webpack_public_path__ + "img/cs2.b5eae330.png";